import { Link } from "react-router-dom";
import { Crown, Timer, Lock } from "lucide-react";

export const AccessBanner = ({ access }) => {
  if (access.plan === "team") {
    return (
      <div className="access-banner access-team" data-testid="access-banner">
        <Crown size={20} /> <span>Team plan active ({access.interval === "year" ? "yearly" : "monthly"})</span>
        <Link to="/pricing" className="underline ml-auto" data-testid="access-manage-link">Manage</Link>
      </div>
    );
  }
  if (access.plan === "trial") {
    return (
      <div className="access-banner access-trial" data-testid="access-banner">
        <Timer size={20} /> <span>Free trial: {access.trial_days_left} day{access.trial_days_left === 1 ? "" : "s"} left. All Team features unlocked.</span>
        <Link to="/pricing" className="underline ml-auto" data-testid="access-plans-link">See plans</Link>
      </div>
    );
  }
  return (
    <div className="access-banner access-free" data-testid="access-banner">
      <Lock size={20} /> <span>Your trial has ended. Coach features are locked until you subscribe.</span>
      <Link to="/pricing" className="btn-primary !min-h-[40px] ml-auto" data-testid="access-subscribe-link">Subscribe</Link>
    </div>
  );
};
